import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';

import studyInfoReducer from "./studyInfoSlice"
import studyMappingReducer from "./studyMappingsSlice"

import unAttachedSensorsDetailsReducer from "./content/sensorsPage/unAttachedSensorsSlice"
import attachedSensorsDetailsReducer from "./content/sensorsPage/attachedSensorsSlice"

import anomalousParticipantsDetailsReducer from "./content/participantPages/anomalousParticipantsSlice"
import unAnomalousParticipantsDetailsReducer from "./content/participantPages/unAnomalousParticipantsSlice"
import unAttachedParticipantsDetailsReducer from "./content/participantPages/unattachedParticipantsSlice"

import tempRangeAnomalyDataSliceReducer from "./content/dashboardPage/tempRangeAnomalyDataSlice"

export const store = configureStore({
    reducer: {
        studyInfo : studyInfoReducer,
        studyMapping : studyMappingReducer,
        
        unAttachedSensorsDetails : unAttachedSensorsDetailsReducer,
        attachedSensorsDetails : attachedSensorsDetailsReducer,
        
        anomalousParticipantsDetails : anomalousParticipantsDetailsReducer,
        unAnomalousParticipantsDetails : unAnomalousParticipantsDetailsReducer,
        unAttachedParticipantsDetails : unAttachedParticipantsDetailsReducer,

        tempRangeAnomalyDataDetail : tempRangeAnomalyDataSliceReducer

    },
    devTools: true,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
